import React from 'react';
import './DrawerTitle.less';

export const DrawerTitle = ({text}) => {
	return <h2 className="drawer-title">{text}</h2>
}
